.container {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
}

.avatar {
  align-items: normal;
}
